import { Link } from "react-router-dom"
import { history } from "store/store"

const { CustomButton } = require("modules/auth/styles")
const { Modal, ModalBody } = require("reactstrap")

const ConfirmUnsavedResponsePopup = ({setOpen, open}) => {
  return (
    <Modal centered fade={false} size='sm' isOpen={open} toggle={() => setOpen(false)}>
      <ModalBody className='pt-5 pb-4'>
        <div className='text-center text-danger'>
          <strong>Are you sure you want to discard the changes?</strong>
        </div>
        <div className='mt-4 d-flex justify-content-center align-items-center'>
          <CustomButton onClick={() => {
            history.push('/responses/create');
            setOpen(false)
            }} className='btn-sm black mx-3'>
            Yes, Discard
          </CustomButton>
          <Link
            to='/'
            className='mx-3 text-dark'
            onClick={(e) => {
              e.preventDefault()
              setOpen(false)
            }}>
            Cancel
          </Link>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ConfirmUnsavedResponsePopup